import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

export default function PartnerMaster() {
   const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    CustomerId: 0,
    CustomerType: "0",
    Name: "",
    Email: "",
    Mobile: "",
    Password: "",
  });

  const [errors, setErrors] = useState({});
  const [partners, setPartners] = useState([]);

  const [permissions, setPermissions] = useState({
    isCreate: true,
    isUpdate: true,
    isDeleted: true,
    isView: true,
  });

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
     const storedUser = JSON.parse(localStorage.getItem("user")) || null;
   
    setUser(storedUser);
    const companyId = storedUser?.companyId
    try {
      const res = await fetch(`${API_BASE_URL}/Home/GetCustomer?CompanyId=${companyId}`);
      const data = await res.json();
      if (data?.data) setPartners(data.data);
      else alert("Failed to load partners");
    } catch {
      alert("Failed to load partners");
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    if (id === "Mobile") {
      const cleaned = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, [id]: cleaned }));
      return;
    }

    setForm((prev) => ({ ...prev, [id]: value }));
  };

  const validate = () => {
    const errs = {};

    if (!form.CustomerType || form.CustomerType === "0")
      errs.CustomerType = "Please Select Customer Type";

    if (!form.Name.trim()) errs.Name = "Please Enter Name";
    if (!form.Email.trim()) errs.Email = "Please Enter Email";
    if (!form.Mobile.trim()) errs.Mobile = "Please Enter Mobile Number";
    if (!form.Password.trim()) errs.Password = "Please Enter Password";

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const clearFields = () => {
    setForm({
      CustomerId: 0,
      CustomerType: "0",
      Name: "",
      Email: "",
      Mobile: "",
      Password: "",
    });
    setErrors({});
  };

  const saveOrUpdateCompany = async () => {
    if (!validate()) return;

    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const companyId = storedUser.companyId ? parseInt(storedUser.companyId) : 0;

    const customerData = {
      Id: form.CustomerId,
      CustomerType: form.CustomerType,
      CompanyId: companyId, // ALWAYS from localStorage
      Name: form.Name,
      Email: form.Email,
      Password: form.Password,
      Mobile: form.Mobile,
      CreatedBy: "Customer_Admin",
    };

    try {
      const formData = new FormData();
      formData.append("modelJson", JSON.stringify(customerData));

      const res = await fetch(`${API_BASE_URL}/Home/InsertUpdateCustomer`, {
        method: "POST",
        body: formData,
      });

      const result = await res.json();
      alert(result.message || "Success");
      clearFields();
      fetchPartners();
    } catch (error) {
      alert("Not Saved");
      console.error(error);
    }
  };

  const updatePartner = (partner) => {
    setForm({
      CustomerId: partner.id,
      CustomerType: partner.customerType,
      Name: partner.name,
      Email: partner.email,
      Mobile: partner.mobile,
      Password: partner.password,
    });

    setErrors({});
  };

  const toggleStatus = async (id, isActive) => {
    if (!window.confirm("Are you sure you want to proceed?")) return;

    const token = localStorage.getItem("token");

    try {
      const res = await fetch(`${API_BASE_URL}/Home/UpdateCustomerStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({ id: parseInt(id), isActive }),
      });

      await res.json();
      alert("Status updated successfully!");
      fetchPartners();
    } catch {
      alert("Error updating status.");
    }
  };

  const deletePartner = async (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    try {
      const res = await fetch(`${API_BASE_URL}/Home/DeleteCustomer/${id}`, {
        method: "POST",
      });

      const result = await res.json();
      alert(result.message || "Deleted");
      clearFields();
      fetchPartners();
    } catch {
      alert("Not Deleted");
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">

        {permissions.isCreate && (
          <div className="card">
            <div className="card-body">
              <div className="main-content-label">Create Partner</div>
              <br />

              <div className="row">
                <div className="col-md-3">
                  <select
                    id="CustomerType"
                    className={`form-control ${errors.CustomerType ? "is-invalid" : ""}`}
                    value={form.CustomerType}
                    onChange={handleChange}
                  >
                    <option value="0">Select User Type</option>
                    <option value="Wholesale">Wholesale</option>
                    <option value="Retail">Retail</option>
                    <option value="Both">Both</option>
                  </select>
                  {errors.CustomerType && <span className="text-danger">{errors.CustomerType}</span>}
                </div>

                <div className="col-md-6">
                  <input
                    className={`form-control ${errors.Name ? "is-invalid" : ""}`}
                    placeholder="Name"
                    id="Name"
                    type="text"
                    value={form.Name}
                    onChange={handleChange}
                  />
                  {errors.Name && <span className="text-danger">{errors.Name}</span>}
                </div>
              </div>

              <br />

              <div className="row">
                <div className="col-md-4">
                  <input
                    className={`form-control ${errors.Email ? "is-invalid" : ""}`}
                    placeholder="Email"
                    id="Email"
                    type="email"
                    value={form.Email}
                    onChange={handleChange}
                  />
                  {errors.Email && <span className="text-danger">{errors.Email}</span>}
                </div>

                <div className="col-md-4">
                  <input
                    className={`form-control ${errors.Mobile ? "is-invalid" : ""}`}
                    placeholder="Mobile Number"
                    id="Mobile"
                    type="text"
                    value={form.Mobile}
                    onChange={handleChange}
                  />
                  {errors.Mobile && <span className="text-danger">{errors.Mobile}</span>}
                </div>

                <div className="col-md-4">
                  <input
                    className={`form-control ${errors.Password ? "is-invalid" : ""}`}
                    placeholder="Password"
                    id="Password"
                    type="text"
                    value={form.Password}
                    onChange={handleChange}
                  />
                  {errors.Password && <span className="text-danger">{errors.Password}</span>}
                </div>
              </div>

              <br />

              <div className="row">
                <div className="col-md-3">
                  <button
                    className="btn btn-primary btn-block"
                    onClick={saveOrUpdateCompany}
                  >
                    Save
                  </button>
                </div>

                <div className="col-md-3">
                  <button
                    className="btn btn-secondary btn-block"
                    onClick={clearFields}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {permissions.isView && (
          <div className="card mt-4">
            <div className="card-body">
              <div className="main-content-label">Partner List</div>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sl No.</th>
                      <th>Type</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Password</th>
                      <th>Active/Inactive</th>
                      {(permissions.isUpdate || permissions.isDeleted) && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {partners.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">No records found.</td>
                      </tr>
                    ) : (
                      partners.map((partner, index) => (
                        <tr key={partner.id}>
                          <td>{index + 1}</td>
                          <td>{partner.customerType}</td>
                          <td>{partner.name}</td>
                          <td>{partner.email}</td>
                          <td>{partner.mobile}</td>
                          <td>{partner.password}</td>

                          <td>
                            <input
                              type="checkbox"
                              checked={partner.isActive}
                              onChange={() => toggleStatus(partner.id, !partner.isActive)}
                              disabled={!permissions.isUpdate}
                            />
                          </td>

                          {(permissions.isUpdate || permissions.isDeleted) && (
                            <td>
                              {permissions.isUpdate && (
                                <button
                                  className="btn btn-sm btn-success me-2"
                                  onClick={() => updatePartner(partner)}
                                >
                                  Update
                                </button>
                              )}

                              {permissions.isDeleted && (
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => deletePartner(partner.id)}
                                >
                                  Delete
                                </button>
                              )}
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
